import React from 'react';
import usePageTitle from 'app/hooks/usePageTitle';
import LogoIcon from 'app/fuse-layouts/shared-components/LogoIcon';
import { ProgressPill } from 'app/components/ProgressPill';
import { useTranslation } from 'react-i18next';

const FuseSplashScreen = () => {
	const { t, ready } = useTranslation(undefined, { useSuspense: false });
	usePageTitle('Loading...');

	return (
		<>
			<div id="fuse-splash-screen">
				<div className="center">
					<div className="logo">
						<LogoIcon width="128" />
					</div>
					<div style={{ height: '200px' }} />
				</div>
			</div>
			<ProgressPill
				messageTitle={ready ? t('Loading') : '\u00A0'}
				messageText={ready ? t('Please wait...') : '\u00A0'}
				size="medium"
			/>
		</>
	);
};

export default React.memo(FuseSplashScreen);
